// src/helpers/rutaTesoreria.js
import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";
const API_BASE = process.env.REACT_APP_API || BASE_URL;

const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token; // tu back usa 'token'
  return config;
});

const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

// Intentar primero /tesoreria y si da 404, probar /tesorerias
const PATHS = ["/tesoreria", "/tesorerias"];

async function getWithFallback(subpath, params = {}) {
  let lastErr = null;
  for (const base of PATHS) {
    try {
      const { data } = await api.get(`${base}${subpath}`, { params });
      return data;
    } catch (e) {
      lastErr = e;
      // si es 404, probamos el siguiente path; si es otro error, cortamos
      if (e?.response?.status !== 404) return { ok: false, msg: parseErr(e) };
    }
  }
  return { ok: false, msg: parseErr(lastErr) || "Endpoint no encontrado (/tesoreria /tesorerias)" };
}

/** Resumen de saldos (cajas, cuentas, emitidos, etc.) */
export const getSaldosTesoreria = async (params = {}) =>
  await getWithFallback("/saldos", params);

/** Detalle de cheques / iCheq EMITIDOS (por OP) */
export const getEmitidosTesoreria = async (params = {}) =>
  await getWithFallback("/emitidos", params);

/** Detalle de valores RECIBIDOS (cartera) */
export const getRecibidosTesoreria = async (params = {}) =>
  await getWithFallback("/recibidos", params);

export default {
  getSaldosTesoreria,
  getEmitidosTesoreria,
  getRecibidosTesoreria,
};
